//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalBuildingsWidget = ({ count }: { count: number }) => {
  return <StatCard title='# of Buildings' stat={count} />;
};

export default TotalBuildingsWidget;
